import { BaseRouteService } from 'core/services';

class ScheduleDateViewRouteService extends BaseRouteService {
    constructor() {
        super('facility-schedule-dates-view');
    }

    find(filter) {
        return super.find(this.base + '/{?searchQuery,page,rpp,sort,embed,fields,dateFrom,dateTo,facilityId,corporateId,accountRepId,payorRepId,intakeRepId,documentRepId,billerRepId,calendarTypeId,isNew,isWoundCare,isOnHold,showCompleted}', filter);
    }
}

export default ScheduleDateViewRouteService;